import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../../axios/axios.config";
import { ConfiguracaoConsignadoTO } from "./configuracao-consignado";

const ConfiguracaoConsignadoService = () => {
  const path = "/configuracoes/consignado";
  const loginService = LoginService();
  return {
    getConfiguracao(): Promise<AxiosResponse<ConfiguracaoConsignadoTO>> {
      return axiosRequest.get(path, {
        headers: loginService.getHeaders(),
      });
    },
  };
};

export default ConfiguracaoConsignadoService;
